/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1PersonSharedAssociatedCompaniesQueryResponse,
  GetApiV1PersonSharedAssociatedCompaniesQueryParams,
  GetApiV1PersonSharedAssociatedCompanies400,
  GetApiV1PersonSharedAssociatedCompanies401,
  GetApiV1PersonSharedAssociatedCompanies500,
} from "../../types/personSharedController/GetApiV1PersonSharedAssociatedCompanies.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1PersonSharedAssociatedCompanies } from "../../clients/personSharedController/getApiV1PersonSharedAssociatedCompanies.ts";

export const getApiV1PersonSharedAssociatedCompaniesQueryKey = (
  params?: GetApiV1PersonSharedAssociatedCompaniesQueryParams,
) =>
  [
    { url: "/api/v1/person/shared/associated-companies" },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1PersonSharedAssociatedCompaniesQueryKey = ReturnType<
  typeof getApiV1PersonSharedAssociatedCompaniesQueryKey
>;

export function getApiV1PersonSharedAssociatedCompaniesQueryOptions(
  params?: GetApiV1PersonSharedAssociatedCompaniesQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1PersonSharedAssociatedCompaniesQueryKey(params);
  return queryOptions<
    GetApiV1PersonSharedAssociatedCompaniesQueryResponse,
    ResponseErrorConfig<
      | GetApiV1PersonSharedAssociatedCompanies400
      | GetApiV1PersonSharedAssociatedCompanies401
      | GetApiV1PersonSharedAssociatedCompanies500
    >,
    GetApiV1PersonSharedAssociatedCompaniesQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1PersonSharedAssociatedCompanies(params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna empresas conveniadas para uso em componentes de seleção, filtradas pelo nome. Quando id é informado, retorna apenas a empresa correspondente. Quando poloId é informado, filtra pelo polo. **(Requer Authorization para autenticação)**
 * @summary Lista de empresas conveniadas para dropdown (Requer Authorization para autenticação)
 * {@link /api/v1/person/shared/associated-companies}
 */
export function useGetApiV1PersonSharedAssociatedCompanies<
  TData = GetApiV1PersonSharedAssociatedCompaniesQueryResponse,
  TQueryData = GetApiV1PersonSharedAssociatedCompaniesQueryResponse,
  TQueryKey extends QueryKey = GetApiV1PersonSharedAssociatedCompaniesQueryKey,
>(
  params?: GetApiV1PersonSharedAssociatedCompaniesQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1PersonSharedAssociatedCompaniesQueryResponse,
        ResponseErrorConfig<
          | GetApiV1PersonSharedAssociatedCompanies400
          | GetApiV1PersonSharedAssociatedCompanies401
          | GetApiV1PersonSharedAssociatedCompanies500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1PersonSharedAssociatedCompaniesQueryKey(params);

  const query = useQuery(
    {
      ...getApiV1PersonSharedAssociatedCompaniesQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1PersonSharedAssociatedCompanies400
      | GetApiV1PersonSharedAssociatedCompanies401
      | GetApiV1PersonSharedAssociatedCompanies500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
